import React, { useEffect, useState } from 'react';
import { Card, Tabs } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import MultipleRegistration from './MultipleRegistration';
import MultipleRegistrationWithCustomID from './MultipleRegistrationWithCustomID';

    export default function MultipleRegistrationWrapper(){
        const { TabPane } = Tabs;

        return(
            <>
                <Card title="General Registration">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="Auto ID" key="1">
                            <MultipleRegistration />
                        </TabPane>
                        <TabPane tab="Custom ID" key="2">
                            <MultipleRegistrationWithCustomID />
                        </TabPane>
                    </Tabs>
                </Card>
            </>
        )
    }